// 🟢 INFRA — proteção contra o bfcache (botão voltar/avançar do navegador).
//
// Restauração via bfcache devolve o documento congelado sem nenhum request —
// a UI autenticada reaparece após o logout e nenhum useEffect re-executa.
// O reload força a visita a passar pelos guards do Rails (ReactController):
// deslogado cai em /, logado em / cai em /site. `event.persisted` só é true
// em restauração de bfcache, então navegação normal não é afetada.
//
// Complementa o `Cache-Control: no-store` do react#index — o Safari ignora
// no-store para fins de bfcache, este listener é a mitigação que vale lá.
export default function installBfcacheReload() {
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) window.location.reload();
  });
}
